// extracted by mini-css-extract-plugin
module.exports = {"container":"Widget_container__Uyssq","title":"Widget_title__kWVXy"};